
import { Component, Prop, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getUpgradePack, upgradeDevice } from "@/api/api-basic";
@Component
export default class UpgradePack extends Vue {
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private initData!: objAny;
  private loading = false;
  private modalShow = false;
  private modalTitle = "设备升级";
  private FormData: objAny = {};
  private versionList: object[] = [];

  private formItem: objAny = {
    snList: [],
    remark: "",
    version: ""
  };
  private ruleInline: objAny = {
    version: [{ required: true, message: "请选择版本号", trigger: "change" }]
  };
  public open(snList: object[]): void {
    this.$nextTick((): void => {
      this.FormData = this.$refs["formItem"];
      this.handleReset();
    });
    this.modalShow = true;
    this.formItem.version = "";
    this.formItem.remark = "";
    this.formItem.snList = snList;

    this.getUpgradePack();
  }
  public handleReset() {
    this.FormData.resetFields();
  }

  public handleSubmit(): void {
    this.FormData.validate((valid: boolean): void => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }

  public closeModal(): void {
    this.modalShow = false;
  }

  async getUpgradePack(): Promise<void> {
    const ret = await getUpgradePack({});
    if (ret.status === this.$config.apiStatus) {
      this.versionList = ret.data;
    }
  }
  async submitData(): Promise<void> {
    const ret = await upgradeDevice(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success("操作成功");
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
